
document.addEventListener("DOMContentLoaded", (event) => {
  let allGridMedia = document.querySelectorAll('.grid__item ');
if(allGridMedia){
  allGridMedia.forEach(function(singleMedia){
    
    singleMedia.addEventListener('onmouseover',function(){
      console.log("mouse overing")
      console.log(this)
      // this.querySelector('video').play()
    })
  });
}
});
function playvideo(element){
  element.querySelector('video').play()
}
function pausevideo(element){
  element.querySelector('video').pause()
}

document.addEventListener("DOMContentLoaded", (event) => {
  let pralltabs = document.querySelectorAll('.prtab');
  pralltabs.forEach(function(prTab){
    prTab.addEventListener('click',function(e){
      e.preventDefault();
      if(this.classList.contains('active')){
        return
      }
      let activeTabTitle = this.getAttribute('data-tab');
      let activeTablist = document.querySelector(`.tabres[data-tab="${activeTabTitle}"]`)
      let activeTab = document.querySelector('.prtab.active');
      let activeTabList = document.querySelector('.tabres.active');
      activeTab.classList.remove('active');
      activeTabList.classList.remove('active');
      this.classList.add('active')
      console.log(activeTablist)
       activeTablist.classList.add('active')
    });
  });

  let financeBUtton = document.querySelector('.financing-button button');
  let financecloseBUtton = document.querySelector('.finance-close');
  let modalpayment = document.querySelector('.modal-payment');
  if(financeBUtton){
    financeBUtton.addEventListener('click',function(e){
      e.preventDefault()
      modalpayment.classList.add('active')
    });
  }
   if(financecloseBUtton){
    financecloseBUtton.addEventListener('click',function(e){
      e.preventDefault()
      modalpayment.classList.remove('active')
    });
  }
});